import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import { IonBackButtonDelegate } from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-why-atom-header',
  template: `
    <ion-toolbar [class]="theme">
      <ion-buttons slot="start" *ngIf="showBackIcon">
        <ion-back-button class="add__color primary-shade" text="" [defaultHref]="defaultHref"></ion-back-button>
      </ion-buttons>
      <ion-buttons slot="end" *ngIf="showHelpIcon" (click)="aboutUs()">
        <ion-icon class="info_icon primary" name="information-circle-outline"></ion-icon>
      </ion-buttons>
      <ion-buttons slot="end" *ngIf="editProfile" (click)="createProfile()">
        <ion-icon class="info_icon" name="pencil-outline"></ion-icon>
      </ion-buttons>
      <ion-title [class]="getTitleClass()" *ngIf="label">{{label}}</ion-title>
      <img src="/assets/img/svg/gigsta_official_logo.svg" *ngIf="logo" class="gigsta-logo" alt="logo"/>
    </ion-toolbar>
  `,
  styleUrls: ['./atom-header.component.scss']
})
export class AtomHeaderComponent implements OnInit, AfterViewInit {
  @ViewChild(IonBackButtonDelegate) backButton: IonBackButtonDelegate;
  @Input() showHelpIcon: boolean;
  @Input() showBackIcon = true;
  @Input() showBellIcon: boolean;
  @Input() label: string;
  @Input() logo: boolean;
  @Input() theme = '';
  @Input() editProfile: boolean;
  @Input() notificationCount = 0;
  @Input() titleClass = 'header-title';
  @Input() defaultHref = '';
  @Input() customBackButton = false;
  @Output() aboutsClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() createEditEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() customBackButtonAction = new EventEmitter<boolean>();

  constructor(private location: Location, public translate: TranslateService, private router: Router) {
  }

  ngOnInit(): void {
  }

  aboutUs() {
    this.aboutsClick.emit('clicked');
  }

  getTitleClass() {
    return 'pd-top-40' + ' header-title ' + this.titleClass;
  }

  createProfile() {
    this.createEditEvent.emit();
  }
  ngAfterViewInit() {
    this.setUIBackButtonAction();
  }

  setUIBackButtonAction() {
    this.backButton.onClick = () => {
      if (this.customBackButton) {
        this.back();
      }
      else {
        this.location.back();
      }
    };
  }
  back() {
    this.customBackButtonAction.emit(true);
  }



}
